import React, { useEffect, useState } from 'react'
import CallAPI from '../../../../adminpanel/components/commonComponents/AxiosHelper';
import LoadingComponent from '../../../../adminpanel/components/commonComponents/LoadingComponent';
import Grid from '../../commonComponents/Grid';
import { ButtonComponent } from '../../../components/commonComponents/UIComponent';
import { formatBytes } from '../../commonComponents/CommonHelper';

const SFTPTypeConnect = ({ authData, initialData, setConnectionType, nextBtnStatus = true, setSelectedFiles, entireData = null }) => {

    const [folderData, setfolderData] = useState({
        folderDetails: {},
        selection: {},
    });
    const [directoryPath, setdirectoryPath] = useState('/');
    let typeGrid = {};
    let availableTypes = {};

    useEffect(() => {
        const abortController =  new AbortController();
        if (entireData == null || (entireData && Object.keys(entireData).length == 0)) {
            fetchPreview(directoryPath);
        }
        
        return () => {
            abortController.abort();
        }
    }, [])

    useEffect(() => {
        if (entireData && Object.keys(entireData).length > 0) {
            setdirectoryPath(entireData.directoryPath)
            setfolderData(entireData)
            setTimeout(() => {
                feather.replace();
            }, 1);
        }
    }, [JSON.stringify(entireData)])

    function fetchPreview(directoryPath) {
        let params = { siteId: authData.siteId }
        let postBody = {
            "connectionId": initialData.connectionId,
            "directoryPath": directoryPath
        }
        setfolderData({ ...folderData, folderDetails: {} });

        CallAPI('post', '/app/fetch_preview_data', postBody, params, 0, function (response) {
            if (response.status === true) {
                let data = response.information;
                setTimeout(() => {
                    feather.replace();
                }, 2);
                setfolderData({ ...folderData, folderDetails: data });
            }
        }, authData)
    }

    const folderEvent = (folderDetails) => {
        let temp = `${directoryPath}`;
        let fileName = folderDetails.name;
        setTimeout(() => {
            feather.replace();
        }, 1);
        if (folderDetails.type == "drill" && folderDetails.fileType == "folder") {
            temp = `${temp}${folderDetails.name}/`;
            setdirectoryPath(temp);
            fetchPreview(temp);
        } else if (folderDetails.fileType == "file-text" && (fileName.includes('.csv') === true || fileName.includes('.txt') === true || fileName.includes('.xlsx') === true || fileName.includes('.accdb') === true)) {
            let tempData = { ...folderData };
            Object.keys(tempData.folderDetails).forEach(element => {
                let tempFolderData = tempData.folderDetails;
                let selectedArray = tempData.selection;
                if (tempFolderData[element].filename == folderDetails.name) {
                    if (tempFolderData[element].selectedStatus === true) {
                        tempFolderData[element].selectedStatus = false;
                        delete selectedArray[tempFolderData[element].filename];
                    } else {
                        tempFolderData[element].selectedStatus = true;
                        selectedArray[tempFolderData[element].filename] = tempFolderData[element];
                    }
                    tempFolderData[element].path = directoryPath;
                }
            });
            setfolderData(tempData);
            if (setSelectedFiles) {
                let newData = { ...tempData, directoryPath: directoryPath }
                setSelectedFiles({...newData});
            }
        }
    }

    const breadEvent = (clickedElement) => {
        let directoryActualValue = directoryPath.split('/');
        let clickedIndex = directoryActualValue.indexOf(clickedElement) + 1;
        directoryActualValue = directoryActualValue.slice(0, clickedIndex).join('/') + "/";
        setdirectoryPath(directoryActualValue);
        fetchPreview(directoryActualValue);
    }

    const handleNextButton = () => {
        setConnectionType({ "connectionId": initialData.connectionId, selectedStep: 4, "connection_type": initialData.connection_type, "selectedFiles": folderData.selection })
    };

    Object.keys(folderData.folderDetails).map(singleFolderName => {
        let tempFolderData = folderData.folderDetails;
        if ([".", ".."].indexOf(tempFolderData[singleFolderName].filename) == -1 && [1, 2].indexOf(tempFolderData[singleFolderName].type) > -1) {
            let typeFile = tempFolderData[singleFolderName].type == "1" ? "file-text" : "folder";
            if (availableTypes[tempFolderData[singleFolderName].type] == undefined) {
                availableTypes[tempFolderData[singleFolderName].type] = {
                    displayType: tempFolderData[singleFolderName].type,
                }
                typeGrid[tempFolderData[singleFolderName].type] = [];
            }
            let tempSize = formatBytes(tempFolderData[singleFolderName].size, 2);
            typeGrid[tempFolderData[singleFolderName].type].push(<Grid
                id={`${singleFolderName}_${Math.floor(Math.random() * 10)}`}
                title={tempFolderData[singleFolderName].filename}
                icon={typeFile}
                description={`Size: ${tempSize}`}
                folderEvent={folderEvent}
                folderDetails={{ "type": "drill", "name": tempFolderData[singleFolderName].filename, "fileType": typeFile }}
                selectedIndicate={folderData.selection[tempFolderData[singleFolderName].filename] ? true : false}
                lastTime={moment.unix(tempFolderData[singleFolderName].mtime).format("YYYY-MM-DD HH:mm:ss")}
                moreOptions={null}
            />)
        }
    })

    let lastindex = directoryPath.split("/").length;
    let breadElements = directoryPath.split("/").map((element, index) => {
        if (index === 0) {
            return <li className="breadcrumb-item" style={{ cursor: 'pointer' }} onClick={() => breadEvent(element)}><a href="javascript:void(0)">/</a></li>;
        } else if (index === lastindex - 2) {
            return <li className="breadcrumb-item active" aria-current="page">{element}</li>
        } else {
            return <li className="breadcrumb-item" style={{ cursor: 'pointer' }} onClick={() => breadEvent(element)}><a href="javascript:void(0)">{element}</a></li>
        }
    })

    let nextStepButton = nextBtnStatus ? { "className": `btn btn-primary btn-sm text-white float-right ${Object.keys(folderData.selection).length > 0 ? null : "disabled"}`, "name": "Next", "type": "add", "icon": "play", "event": handleNextButton } : null;

    let displayNodes = Object.keys(availableTypes).length > 0 && Object.keys(typeGrid).length > 0 ?
        Object.keys(availableTypes).map(function (types) {
            return (
                <>
                    <label className="d-block tx-medium tx-12 tx-uppercase tx-sans tx-spacing-1 tx-color-03 mg-t-20 mg-b-15" key={`individualLabel_${types}`}>
                        {types === "1" ? 'Files' : 'Folders'}
                    </label>
                    <div className="row row-xs" key={`individualRow_${types}`}>
                        {typeGrid[types]}
                    </div>
                </>
            )
        })
        : <h5 className="text-center mg-100">Folder is empty</h5>;

    return (
        <>
            <div className="card-header">
                <div>
                    <h6 className="card-title d-inline">{initialData.connection_name}</h6>
                    {nextBtnStatus ? <ButtonComponent buttonData={nextStepButton}></ButtonComponent> : null}
                </div>
                <div>
                    <p className="bootstrap-tagsinput">
                        {Object.values(folderData.selection).map(function (innerData) {
                            return <span className="tag label label-info">
                                {`Path: ${innerData.path}, FileName: ${innerData.filename}`}
                            </span>
                        })}
                    </p>
                </div>
            </div>
            <div className="card-body">
                <nav className="d-inline-block" aria-label="breadcrumb">
                    <ol className="breadcrumb breadcrumb-style2 mg-b-0">
                        {breadElements}
                    </ol>
                </nav>
                <span className="alert alert-primary float-right pd-8 tx-medium tx-12 tx-sans">
                    <i data-feather="alert-circle" className="mg-r-10" width="20" height="20"></i>Selection of Comma Separated Values (.csv), Text (.txt), MS Access (.accdb) and Excel (.xlsx) Files permitted.
                </span>
                {Object.keys(folderData.folderDetails).length > 0 ? displayNodes : <LoadingComponent />}
            </div>
        </>
    )
}
export default SFTPTypeConnect;
